/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_CAM_FIELDS_ITEM = {
  id: 'agro_campos_main',
  screenId: 'agr-cam-fields',
  label: 'Campos',
  description: 'Alta de campos y zonas con mapa, dirección y superficie.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá cargás los campos de la empresa y, dentro de cada uno, las zonas (lotes o ambientes). El resto del módulo Agro (clima, suelos, siembras, eventos) se apoya en estos datos.',
      },
      {
        title: 'Pestañas',
        bullets: [
          'Campos — lista de establecimientos o parcelas principales.',
          'Zonas — subdivisiones dentro de un campo (lote, ambiente, etc.).',
        ],
      },
      {
        title: 'Paso 1 — Ver campos',
        bullets: [
          'La lista muestra: Nombre, Dirección, Superficie y cantidad de Zonas.',
          'Tocá una fila para ver el detalle.',
          'El lápiz abre la edición; el tachito elimina (si el campo no tiene dependencias que lo impidan).',
          'El botón + abre la ventana de alta.',
        ],
      },
      {
        title: 'Paso 2 — Nuevo o editar campo',
        fields: [
          {
            label: 'Nombre',
            description: 'Cómo vas a reconocer el campo en el sistema (obligatorio).',
          },
          {
            label: 'Calle / ruta',
            description: 'Dirección o acceso al campo.',
          },
          {
            label: 'Localidad',
            description: 'Pueblo o ciudad de referencia.',
          },
          {
            label: 'Código postal',
            description: 'CP de la zona.',
          },
          {
            label: 'Provincia',
            description: 'Provincia donde está el campo.',
          },
          {
            label: 'País',
            description: 'País (por ejemplo Argentina).',
          },
          {
            label: 'Límite del campo (mapa)',
            description:
              'Dibujá el perímetro en el mapa. Sirve de base para las zonas y para ubicar análisis o clima. Podés ajustar o borrar el dibujo desde las herramientas del mapa.',
          },
        ],
        paragraphs: ['Tocá «Guardar» o «Guardar cambios» para confirmar.'],
      },
      {
        title: 'Paso 3 — Zonas',
        intro: 'En la pestaña Zonas gestionás las partes del campo.',
        bullets: [
          'Podés filtrar por campo.',
          'La lista muestra: Zona, Campo y Superficie.',
          'El botón + abre el alta de zona.',
        ],
        fields: [
          {
            label: 'Campo',
            description: 'Campo al que pertenece la zona (obligatorio).',
          },
          {
            label: 'Nombre de la zona',
            description: 'Ej.: Lote 1, Ambiente alto, etc.',
          },
          {
            label: 'Límite en el mapa',
            description:
              'Dibujá el polígono de la zona. Si el campo tiene límite cargado, se muestra como referencia para no dibujar afuera.',
          },
        ],
      },
      {
        title: 'Antes de seguir',
        paragraphs: [
          'Conviene cargar al menos un campo (y sus zonas si las usás) antes de climatología, suelos, siembras o eventos.',
        ],
      },
    ],
  },
}
